import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

import locationService from "@plannel/services/data/location-service";
import resourceService from "@plannel/services/data/resource-service";

import debug from "@plannel/utils/debug-util";
import { isEqual, isEmpty } from "lodash";

const AutocompleteSearch = ({ label, value, setValue, optionLabelProp, optionEqualProp, data, target, requestParams, sx }) => {
  const { t } = useTranslation();

  const loading = useRef(false);
  const [options, setOptions] = useState([]);

  const retrieveLocation = () => {
    locationService.getAll({ pagination: false, ...requestParams })
      .then(response => {
        const { results } = response.data;
        setOptions(results);
      })
      .catch(e => {
        debug(e);
      })
      .then(() => {
        loading.current = true;
      });
  }

  const retrieveResource = () => {
    resourceService.getAll()
      .then(response => {
        const { results } = response.data;
        setOptions(results);
      })
      .catch(e => {
        debug(e);
      })
      .then(() => {
        loading.current = true;
      });
  }

  const retrieveTarget = target => {
    if (isEqual(target, "location")) {
      retrieveLocation();
    } else if (isEqual(target, "resource")) {
      retrieveResource();
    }
  }

  useEffect(() => {
    if (data) {
      setOptions(data);
      loading.current = true;
    } else {
      retrieveTarget(target);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const LoadingFilter = () => {
    return (
      <FormControl size="small" sx={{ mr: 1.5, minWidth: 190 }} key={"loading"}>
        <InputLabel>Loading...</InputLabel>
      </FormControl>
    )
  }

  return (
    loading.current ?
      <Autocomplete
        key={"search"}
        options={options}
        getOptionLabel={option => option?.[optionLabelProp] || option?.[optionEqualProp] || ""}
        value={!isEmpty(options) ? value : null}
        onChange={(_, newValue) => setValue(newValue)}
        isOptionEqualToValue={(option, value) => {
          if (isEmpty(options)) {
            return false;
          } else {
            return isEqual(option[optionEqualProp], value[optionEqualProp]);
          }
        }}
        size="small"
        sx={{ mr: 1, minWidth: 200, ...sx }}
        renderInput={params => (
          <TextField {...params} label={t(label)} />
        )}
      /> : <LoadingFilter />
  )
}

export default AutocompleteSearch;